import { useField } from "formik"
import FormikDropDown from "../../../helpers/formikInputs/FormikDropDown"

export default function OccupantFormRentFrequency({
  isSubmitting,
  noRentDueValue,
  weeklyOptions,
  monthlyOptions,
  onFrequencyOptionChange,
}) {
  const [, , frequencyDetailHelper] = useField("rentFrequencyDetail")
  const [, , rentValueHelper] = useField("rentValue")
  const [, , rentGraceDaysHelper] = useField("rentGraceDays")

  const onFrequencyChange = (value) => {
    switch (value) {
      case "Weekly":
        onFrequencyOptionChange(weeklyOptions)
        break
      case "Monthly":
        onFrequencyOptionChange(monthlyOptions)
        break
      case noRentDueValue:
        rentValueHelper.setValue(0)
        rentGraceDaysHelper.setValue(0)
        break
      default:
        break
    }

    frequencyDetailHelper.setValue(null)
  }

  return (
    <FormikDropDown
      name="rentFrequency"
      label="Rent frequency"
      helpText="How often will the rent be due for this bed?"
      options={["Daily", "Weekly", "Monthly", noRentDueValue]}
      onChangeCallback={onFrequencyChange}
      disabled={isSubmitting}
    />
  )
}
